import $ from 'jquery'
import 'jquery-ui/dist/jquery-ui.js'
// @ts-ignore
import IScroll from 'iscroll'
// @ts-ignore
import drawer from 'jquery-drawer'

declare global {
    interface JQueryStatic {
        drawer: drawer
    }
    interface Window {
        IScroll: IScroll
    }
}

window.IScroll = IScroll

var mediaQuery_mobile = window.matchMedia('(max-width: 767px)')
var mediaQuery_tablet = window.matchMedia('(max-width: 1023px)')


function _header_scroll() {
    var i = document.documentElement.scrollTop || document.body.scrollTop,
        e = Array.prototype.slice.call(document.getElementsByTagName("html"))[0];
    140 <= i ? e.classList.add("scrolledPage") : e.classList.remove("scrolledPage"), mediaQuery_tablet.matches && closeHeaderMenu()
}
$(window).on("load", function() {
    header_init()
}), $(document).ready(function() {
    $(".kv").length, setTimeout(function() {
        $("html").removeClass("-loading"), $("html").addClass("-loaded-kv")
    }, 200)
}), window.addEventListener("scroll", _header_scroll), _header_scroll();
var currentWidth = window.innerWidth;

function header_init() {
    showHeaderMenu(), _header_scroll()
}
window.addEventListener("resize", function() {
    currentWidth != window.innerWidth && (currentWidth = window.innerWidth, header_init())
});

function openChildMenu(t: JQuery<HTMLElement>, i: JQuery<HTMLElement>) {
    var e = t,
        s = i;
    e.find(".menu__panel").length && (e.hasClass(classOpen) ? (e.removeClass(classOpen), $("html").removeClass(classHtmlOpen)) : (s.removeClass(classOpen), e.addClass(classOpen), $("html").addClass(classHtmlOpen)))
}

const _ua = function(t) {
    return -1 != t.indexOf("windows") && $("html").addClass("win"), {
        Tablet: -1 != t.indexOf("windows") && -1 != t.indexOf("touch") && -1 == t.indexOf("tablet pc") || -1 != t.indexOf("ipad") || -1 != t.indexOf("android") && -1 == t.indexOf("mobile") || -1 != t.indexOf("firefox") && -1 != t.indexOf("tablet") || -1 != t.indexOf("kindle") || -1 != t.indexOf("silk") || -1 != t.indexOf("playbook"),
        Mobile: -1 != t.indexOf("windows") && -1 != t.indexOf("phone") || -1 != t.indexOf("iphone") || -1 != t.indexOf("ipod") || -1 != t.indexOf("android") && -1 != t.indexOf("mobile") || -1 != t.indexOf("firefox") && -1 != t.indexOf("mobile") || -1 != t.indexOf("blackberry")
    }
}(window.navigator.userAgent.toLowerCase());


function showHeaderMenu() {
    mediaQuery_mobile.matches ? $(".menuFunc .menu__item .menu__link").on("click", function() {
        return openChildMenu($(this).parent(".menu__item"), $(".menuFunc").find(".menu__item")), !1
    }) : (_ua.Tablet && $(".menu__link .menu__item").on("touchstart", function() {
        // C&C Injection for Tablet touch = hover behaviour
        $('.menu__item').removeClass('-panel-open -current');
        $(this).closest('.menu__item').addClass('-panel-open -current');
        // C&C Injection for Tablet touch = hover behaviour END
        return openChildMenu($(this).parent(".menu__item"), $(".menu").find(".menu__item")), !1
    }), $('.menu__item:not(.search)').hover(function() {
        var t = $(this), i = $(".menu").find(".menu__item");
        t.find(".menu__panel").length && (
            t.hasClass(classOpen) ? (
                t.removeClass(classOpen),
                    $("html").removeClass(classHtmlOpen)
            ) : (
                i.removeClass(classOpen),
                    t.addClass(classOpen),
                    $("html").addClass(classHtmlOpen)
            ))
    }), $(".search .menu__link").on("click", function() {
        var t = $(this).parent(".search"),
            i = $(".menu").find(".menu__item");
        t.find(".menu__panel").length && (t.hasClass(classOpen) ? (t.removeClass(classOpen), $("html").removeClass(classHtmlOpen)) : (i.removeClass(classOpen), t.addClass(classOpen), $("html").addClass(classHtmlOpen), setTimeout(function() {
            t.find('input[type="text"]').focus()
        }, 200)))
    }))
}

var classOpen = '-panel-open',
    classHtmlOpen = '-menu-open'

function keydown_header(t: JQuery.KeyDownEvent) {
    27 == t.keyCode && closeHeaderMenu()
}

function closeHeaderMenu() {
    $('html').hasClass('-menu-open') && ($('html').removeClass('-menu-open'), $('.menu__item').removeClass('-panel-open'))
}

var movefun = function (t: Event) {
    t.preventDefault()
}

function elastic_header(t: JQuery<HTMLElement>) {
    var i = '-opened',
        s = t.parent('.elastic__item'),
        n = s.find('.elastic__detail')
    if (s.hasClass(i)) {
        s.removeClass(i)
        n.stop().animate(
            {
                opacity: 0,
                height: 'toggle'
            }
        )
    } else {
        s.addClass(i)
        n.stop().animate(
            {
                opacity: 1,
                height: 'toggle'
            }
        )
    }
}

$(document).keydown(keydown_header), $(document).bind('click touchstart', function (t: JQuery.TriggeredEvent) {
    !$(t.target).parents('.-panel-open').length && $('html').hasClass(classHtmlOpen) && closeHeaderMenu()
})

document.addEventListener('DOMContentLoaded', () => {
    $('.drawer').drawer()
    $('.drawer-toggle').click(function () {
        var t = $(this)
        closeHeaderMenu()
        if ($('body').hasClass('drawer-open')) {
            t.removeClass('-closed')
            window.addEventListener('touchmove', movefun, {
                passive: !1
            })
        } else {
            t.addClass('-closed')
            $('body').removeClass('modal-flash-start')
        }
        window.removeEventListener('touchmove', movefun)
    })
    if ($('.elastic__item').length) {
        $('.elastic__header.menu__link').each(function () {
            $(this).click(function () {
                const t = $(this)
                if (t.parents('.elastic').hasClass('-only-sp')) {
                    if (mediaQuery_mobile.matches) {
                        elastic_header(t)
                    } else {
                        elastic_header(t)
                    }
                }
            })
        })

    }

    // Toggle profile menu
    const profileMenuToggle = document.querySelector('.profileIconWrap') as HTMLElement | null;
    const profileMenu = document.querySelector('.menu__item.profile') as HTMLElement | null;
    if (profileMenuToggle && profileMenu) {
        profileMenuToggle.addEventListener('click', e => {
            e.preventDefault()
            e.stopPropagation()
            profileMenu.classList.toggle('-opened')
            if (mediaQuery_mobile.matches) {
                document.querySelector('html')?.classList.toggle(classHtmlOpen)
            }
        });

        document.body.addEventListener('click', () => {
            if (profileMenu.classList.contains('-opened')) {
                profileMenu.classList.remove('-opened')
                if (mediaQuery_mobile.matches) {
                    document.querySelector('html')?.classList.remove(classHtmlOpen)
                }
            }
        })
    }
})

